/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_ReviewInputs */

const en_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const de_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfen`)
};

const es_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const fr_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Examiner`)
};

const nl_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleren`)
};

const it_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi`)
};

const pt_br2_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const pl_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const hu_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áttekintés`)
};

const ro_admin_dashboard_review = /** @type {(inputs: Admin_Dashboard_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revizuire`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Admin_Dashboard_ReviewInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_review = /** @type {((inputs?: Admin_Dashboard_ReviewInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_ReviewInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_review(inputs)
	if (locale === "de") return de_admin_dashboard_review(inputs)
	if (locale === "es") return es_admin_dashboard_review(inputs)
	if (locale === "fr") return fr_admin_dashboard_review(inputs)
	if (locale === "nl") return nl_admin_dashboard_review(inputs)
	if (locale === "it") return it_admin_dashboard_review(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_review(inputs)
	if (locale === "pl") return pl_admin_dashboard_review(inputs)
	if (locale === "hu") return hu_admin_dashboard_review(inputs)
	return ro_admin_dashboard_review(inputs)
});
export { admin_dashboard_review as "admin.dashboard.review" }